import { Lightning, Utils } from "@lightningjs/sdk";
import { OnNowCard } from "./OnNowCard";
import { Row } from "./Row";
import { FOCUS_TRANSITION, UNFOCUSED_ROW_ALPHA } from "./focus";
export class OnNowRow extends Row {
    constructor() {
        super(...arguments);
        this._updateCardOpacity = () => {
            const list = this.tag("List");
            const wrapper = list.wrapper;
            wrapper.children.forEach((card) => {
                const left = wrapper.x + card.x;
                // Allow subpixel rounding at the clipped viewport edges.
                const fullyVisible = left >= -0.5 && left + card.w <= list.w + 0.5;
                const alpha = fullyVisible ? 1 : UNFOCUSED_ROW_ALPHA;
                if (card.getSmooth("alpha") !== alpha) {
                    card.setSmooth("alpha", alpha, FOCUS_TRANSITION);
                }
            });
        };
    }
    _active() {
        this._updateCardOpacity();
        // Follow the actual scroll position, including interrupted transitions.
        this.stage.on("frameStart", this._updateCardOpacity);
    }
    _inactive() {
        this.stage.off("frameStart", this._updateCardOpacity);
    }
    _detach() {
        this.stage.off("frameStart", this._updateCardOpacity);
    }
    static _template() {
        const row = super._template();
        return Object.assign(Object.assign({}, row), { h: this.H, Channel: {
                y: 79,
                Logo: {
                    w: 116.763,
                    h: 41.114,
                    texture: Lightning.Tools.getSvgTexture(Utils.asset("images/navbar/ligue-1-plus.svg"), 234, 82),
                },
                Badge: {
                    y: 47.093,
                    w: 112,
                    h: 39.657,
                    rect: true,
                    color: 0xffff77e7,
                    shader: { type: Lightning.shaders.RoundedRectangle, radius: 20 },
                    Label: {
                        x: 56,
                        y: 19.8285,
                        mount: 0.5,
                        text: {
                            text: "24/7",
                            fontFace: "Insatiable Display",
                            fontStyle: "700",
                            fontSize: 22.841,
                            lineHeight: 28,
                            h: 28,
                            offsetY: 23,
                            textColor: 0xff000000,
                            precision: 1,
                        },
                    },
                },
            }, List: Object.assign(Object.assign({}, row.List), { x: 141, w: 1664, h: this.H, clipping: true }) });
    }
    set items(items) {
        super.items = items.map((item, index) => (Object.assign(Object.assign({}, item), { next: items[index + 1] })));
    }
    createCard(item) {
        return Object.assign(Object.assign({}, item), { item, type: OnNowCard });
    }
}
OnNowRow.H = OnNowCard.H;
export default OnNowRow;
//# sourceMappingURL=OnNowRow.js.map